/* eslint-disable */

var domain = "US";
/*****************************************************/
//regular expressions to extract IP and country values
const countryCodeExpression = /loc=([\w]{2})/;
const userIPExpression = /ip=([\w\.]+)/;

//automatic country determination.
function initCountry() {
   return new Promise((resolve, reject) => {
        var xhr = new XMLHttpRequest();
        xhr.timeout = 3000;
        xhr.onreadystatechange = function () {
            if (this.readyState == 4) {
                if (this.status == 200) {
                    let countryCode = countryCodeExpression.exec(this.responseText)
                    let ip = userIPExpression.exec(this.responseText)
                    if (countryCode === null || countryCode[1] === '' ||
                        ip === null || ip[1] === '') {
                        reject('IP/Country code detection failed');
                    }
                    let result = {
                        "countryCode": countryCode[1],
                        "IP": ip[1]
                    };
                    resolve(result)
                } else {
                    reject(xhr.status)
                }
            }
        }
        xhr.ontimeout = function () {
            reject('timeout')
        }
        xhr.open('GET', 'https://www.cloudflare.com/cdn-cgi/trace', true);
        xhr.send();
   });
}
// Call `initCountry` function 
initCountry().then(result => {
   let obj = JSON.parse(JSON.stringify(result));
   if(obj.countryCode!="US") {
      document.querySelectorAll('.ls-track-section').forEach(function(el) {
el.style.display = 'none';
});
   }
}).catch(e => console.log(e));
/*****************************************************/

if(domain=="AU") {
  document.getElementById('ls-track-heading-text').innerText='EDIT POST CODE';
  document.getElementById('ls-track-heading-desc').innerText='Enter a post code to see when it will arrive.';
  document.getElementById('zipcode').placeholder="Enter Post Code";
} else {
  document.getElementById('ls-track-heading-text').innerText='EDIT ZIP CODE';
  document.getElementById('ls-track-heading-desc').innerText='Enter a ZIP code to see when it will arrive.';
  document.getElementById('zipcode').placeholder="Enter Zip Code";
}

function get(name) {
if(name=(new RegExp('[?&]'+encodeURIComponent(name)+'=([^&]*)')).exec(location.search))
   return decodeURIComponent(name[1]);
}

const atcForm = document.querySelector('.shopify-product-form')
if (atcForm) {
     atcForm.addEventListener('keydown', e => {
          if (e.keyCode === 13) {
               const focusedInput = atcForm.querySelector('input:focus')
               if (focusedInput) {
                    if (focusedInput.id === 'zipcode') {
                         e.preventDefault()
                         myFunction()
                    }
               }
          }
     })
}

document.querySelector("#ls-close").addEventListener('click', function (e) {
document.getElementById('zipcode').value="";
document.getElementById("output-desc").innerHTML="";
}, false);

document.getElementById("track-submit").onclick = function() {myFunction()};
function myFunction() {

var domain = "US";
console.log("domain"+domain);

var to_pincode = document.getElementById('zipcode').value;
const url = "https://app.lateshipment.com/princesspolly/ls_estimateddelivery.php?to_pincode="+to_pincode+"&domain="+domain;
fetch(url, {
   method : "POST",
   // body: new FormData(document.getElementById("ls_topincode")),
   // -- or --
   // body : JSON.stringify({
   //     user : document.getElementById('ls_topincode').value
   // })
}).then(
   response => response.text() // .json(), etc.
).then(function(html) {
   document.getElementById("output-desc").innerHTML=html;
   startTimer();
});
}

function startTimer() {

clearInterval(downloadTimer);
var timeleft = document.getElementById('remaining_time').getAttribute('data-value');
document.getElementById('progressBar').value = timeleft;
var hours = Math.floor(timeleft / 60);
var minutes = timeleft % 60;
document.getElementById('remaining_time').innerHTML = hours +'hrs '+minutes+'mins';
          
var downloadTimer = setInterval(function() {
  
  console.log(timeleft);
  if(timeleft <= 0) {
   clearInterval(downloadTimer);
  }
  document.getElementById('progressBar').value = timeleft;
  hours = Math.floor(timeleft / 60);
  minutes = timeleft % 60;
  document.getElementById('remaining_time').innerHTML = hours +'hrs '+minutes+'mins';
  timeleft -= 1;
}, 60000);

}